export default __webpack_public_path__ + "media/music/8f6871dc43f1743267c6c931721ec0cb.mp3";